import { useTranslation } from "react-i18next";
import { useRemoteMutation } from "../useRemote/useRemoteMutation";
import { RemoteApiError } from "../useRemote/types";
import { getOrgBackend } from "../../../app/backend";

export type UpdateNotificationSettingsDto = {
  enabledNotifications: string[];
  bookingStartReminderMinutes?: number;
  bookingCheckInReminderMinutes?: number;
  fleetBookingStartReminderMinutes?: number;
  fleetAdminBookingStartReminderMinutes?: number;
  fleetBookingEndReminderMinutes?: number;
  fleetAdminBookingEndReminderMinutes?: number;
  /** Null clears scope on BE when approval-admin is off; omit when unchanged. */
  approvalNotificationBookingInventoryIds?: number[] | null;
};

/**
 * Forward enabled names of notifications and BE stores it accordingly.
 */
export function useRemotePatchNotificationSettings() {
  const { t } = useTranslation();

  return useRemoteMutation<void, RemoteApiError, UpdateNotificationSettingsDto>({
    key: "patch-userinfo-setting-notification",
    url: `${getOrgBackend()}/user-info/setting/notification`,
    method: "patch",
    snackbarTextOnFail: t(`There was a server error`)
  });
}
